<template>
  <v-card>
    <v-card-title class="headline">
      {{ $t("title.create_subscription_mandate") }}
    </v-card-title>

    <v-card-text>
      <v-form
        spellcheck="false"
        ref="form"
        v-model="formValid"
        @submit.prevent="onSubmit"
      >
        <v-row>
          <v-col>
            <LicensePlateField
              ref="license_plate_field"
              v-model="form.license_plate"
              required
              @valid="valid => (licensePlateValid = valid)"
              @validating="
                validating => (validatingLicensePlateLoader = validating)
              "
            />
            <AvailableSubscriptionsSelect
              v-model="form.subscription_uuid"
              required
              class="mt-3"
              showDiscountPrice
            />
            <DatePickerMenu
              v-model="form.subscription_start_date"
              :label="$t('label.start_date')"
              class="mt-3"
              disabled
            />
          </v-col>
        </v-row>

        <div class="d-flex align-center mt-4">
          <v-checkbox v-model="hasAcceptedTos"></v-checkbox>
          <p class="pa-0 ma-0" v-html="termsAndConditionsText"></p>
        </div>

        <v-card-actions class="px-0">
          <v-btn text color="grey" :disabled="loading" @click="$emit('cancel')">
            {{ $t("button.cancel") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!canSave"
          >
            {{ $t("button.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import LicensePlateField from "@/components/fields/LicensePlateField.vue";
import AvailableSubscriptionsSelect from "@/components/fields/AvailableSubscriptionsSelect.vue";
import DatePickerMenu from "@/components/fields/DatePickerMenu.vue";

export default {
  name: "MandateAlreadyRegisteredDialog",
  components: {
    DatePickerMenu,
    AvailableSubscriptionsSelect,
    LicensePlateField
  },
  data() {
    return {
      form: {
        license_plate: {
          license_plate: this.$store.state.user.license_plate,
          license_plate_country_code:
            this.$store.state.user.license_plate_country_code || "NLD"
        },
        subscription_uuid: null,
        subscription_start_date: new Date()
      },
      formValid: false,
      licensePlateValid: false,
      validatingLicensePlateLoader: false,
      submitting: false,
      hasAcceptedTos: false
    };
  },
  computed: {
    loading() {
      return this.validatingLicensePlateLoader || this.submitting;
    },
    canSave() {
      if (!this.formValid) return false;
      if (this.loading) return false;
      if (!this.licensePlateValid) return false;
      if (!this.hasAcceptedTos) return false;
      return true;
    },
    termsAndConditionsText() {
      const link = this.$router.resolve({ name: "auth_termsandconditions" }).href;
      return this.$t("linked.terms_and_conditions", { link });
    }
  },
  mounted() {
    if (this.form.license_plate.license_plate) {
      this.$refs.license_plate_field.validateLicensePlate();
    }
  },
  methods: {
    onSubmit() {
      if (!this.$refs.form.validate() || !this.canSave) return;
      this.submitting = true;
      this.$store.dispatch("subscription/setRegisterData", {
        user_email: this.$store.state.user.email,
        uuid: this.form.subscription_uuid,
        has_accepted_tos: this.hasAcceptedTos,
        license_plate: this.form.license_plate.license_plate,
        license_plate_country_code: this.form.license_plate
          .license_plate_country_code
      });
      this.$store
        .dispatch("subscription/subscribe_already_registered")
        .catch(error => {
          this.$emit("error", error);
          this.$store.commit("viewstate/notify", {
            text: this.$t("error.subscription_create_failed"),
            color: "error"
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
